import AppSession from '../../session/AppSession';

export default {
    data() {
        return {
            popupDialog: {
                sessionExpired: {
                    loader: false,
                    okText: '再ログイン', //Re-login
                    cancelText: '閉じる', //Close
                    animation: 'zoom',
                    backdropClose: true
                }
            }
        };
    },
    methods: {
        async checkActiveSession(networkAccessOnly = false){
            let appSession = new AppSession();
            return appSession.isSessionActive().then(res => {
                let active = true;
                if(res == AppSession.SESSION_EXPIRED && !networkAccessOnly){
                    this.DialogMixin_expiredSessionPrompt();
                    active = false;
                }else if(res == AppSession.SESSION_UNREACHABLE){
                    this.DialogMixin_networkUnreachablePrompt();
                    active = false;
                }
                return active;
            });
        },
        DialogMixin_expiredSessionPrompt(){
            this.$dialog.alert({
                title: "セッションが終了しました", //Session Ended
                body: "セッションが終了しました。再度、ログインしてください。" //Your session has ended. Please log in again.
            }, this.popupDialog.sessionExpired)
            .then(() => this.$router.push("/signin"))
            .catch(() => this.$router.push("/signin"));
        },
        DialogMixin_networkUnreachablePrompt(){
            this.$dialog.alert({
                title: "Offline",
                body: "顧客管理サーバーと通信できません。ネットワーク接続をお確かめください。" //Cannot communicate with customer management server; please  check your network connection.
            }, this.popupDialog.sessionExpired)
            .then(() => location.reload());
        }
    }
};